import React from 'react';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { materialTheme } from './CustomCalendar';
import { MuiThemeProvider } from '@material-ui/core/styles';

const CalendarDateRange = (props) => {
  const onStartDateChange = props.onStartDateChange ? props.onStartDateChange : (_) => {};
  const onEndDateChange = props.onEndDateChange ? props.onEndDateChange : (_) => {};
  const startDate = props.startDate ? props.startDate : new Date();
  const endDate = props.endDate ? props.endDate : new Date();

  return (
    <MuiThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className='grid gap-2 grid-cols-2'>
          <div>
            <DatePicker
              variant='outlined'
              className='datepicker'
              format='dd/MM/yyyy'
              value={startDate}
              onChange={(e) => onStartDateChange(e)}
            />
          </div>
          <div>
            <DatePicker
              variant='outlined'
              className='datepicker'
              format='dd/MM/yyyy'
              value={endDate}
              onChange={(e) => onEndDateChange(e)}
            />
          </div>
        </div>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};

export default CalendarDateRange;
